// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3) return "main." + __webpack_require__.h() + ".css";
	// return url for filenames based on template
	return "" + ({"0":"ang-search","1":"asset-versions-metrics","2":"client-applications","4":"page-editor","5":"publish-form-v1","6":"publish-form-v2","7":"settings","8":"top-rank-metrics"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".css";
};